import { useEffect, useRef } from "react";

import { trackRumLoginView } from "@app/rumMonitoring";
import {
  getPlatformFromCookie,
  readInAppLoginCookie,
} from "hooks/useInAppLogin";

/**
 * Reports a settled login screen to RUM, classified as a lost session or a
 * cold start.
 *
 * `isFormVisible` must mean the login *form* is on screen, not the login
 * route. While WebView auto-login is in flight the page renders a loader, so
 * firing on route entry would report every successful WebView launch as a
 * failure.
 */
export function useLoginViewSignal(isFormVisible: boolean): void {
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (!isFormVisible) {
      hasFiredRef.current = false;
      return;
    }

    if (hasFiredRef.current) return;
    hasFiredRef.current = true;

    trackRumLoginView({
      platform: getPlatformFromCookie(),
      hasAutoLoginCookie: readInAppLoginCookie() !== null,
    });
  }, [isFormVisible]);
}
